  
import React from "react"
import { graphql } from "gatsby"

import MainLayout from "../layouts/mainLayout"

export default (data) => <MainLayout props={data}/>

export const query = graphql`
  query page($id: String!) {
    page: wpPage(id: { eq: $id }) {
       content
    }
  }
`